module.exports = "/static/js/1a6118fff90e5941ec6fef15a5f528df.png";